import { type AnyAction, combineReducers } from 'redux';

import StoreORM from 'js/src/data/store-orm';
import {
    clearLuminaryThumbnail,
    storeLuminaryThumbnail,
} from 'js/src/data/thumbnail-previews/thumbnail-previews-actions';
import type { LuminaryThumbnail } from 'js/src/data/thumbnail-previews/thumbnail-previews-types';

export function luminaryThumbnails(
    state = StoreORM.newFromIdPrefix<LuminaryThumbnail, string | number>('thumbnails').data,
    action: AnyAction,
) {
    if (storeLuminaryThumbnail.match(action)) {
        const orm = new StoreORM<LuminaryThumbnail, string | number>(state);
        // If there's already an entry overwrite it
        const entry = orm.getByIdOrUndefined(action.payload.id);

        if (entry) {
            orm.updateById(action.payload.id, {
                key: ['previewCanvas'],
                value: action.payload.image,
            });
        } else {
            orm.pushJSItem(
                {
                    id: action.payload.id as number,
                    previewCanvas: action.payload.image,
                },
                'id',
            );
        }

        return orm.data;
    }

    if (clearLuminaryThumbnail.match(action)) {
        const orm = new StoreORM<LuminaryThumbnail, string | number>(state);
        orm.delete([action.payload.id]);
        return orm.data;
    }

    return state;
}

export const thumbnailPreviews = combineReducers({
    luminaryThumbnails,
});

export type ThumbnailPreviewsState = ReturnType<typeof thumbnailPreviews>;
